import { useQuery } from 'react-query';
import { getVideoResumeByIdQuery, getVideoResumes } from 'src/apis/videoResume';
import { getVideoResumeTemplateByRole } from 'src/apis/videoResumeTemplate';
import {
	GetVideoResumeByIdAPIResponse,
	GetVideoResumeTemplateByIdAPIResponse,
	GetVideoResumesAPIResponse,
} from 'types';

export const useGetVideoResumeByUserIdQuery = (
	id: string,
	onComplete?: (data: GetVideoResumeByIdAPIResponse) => void,
) => {
	return useQuery({
		queryKey: ['getVideoResumeByIdQuery', id],
		queryFn: async () => (await getVideoResumeByIdQuery(id)) as GetVideoResumeByIdAPIResponse,
		staleTime: 0,
		refetchOnMount: true,
		enabled: !!id,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
	});
};

export const useGetAllVideoResumeQuery = (onComplete?: (data: GetVideoResumesAPIResponse) => void) => {
	return useQuery({
		queryKey: ['getVideoResumes'],
		queryFn: async () => (await getVideoResumes()) as GetVideoResumesAPIResponse,
		staleTime: 0,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
	});
};

export const useGetVideoResumeTemplateByRoleQuery = (
	role: string,
	onComplete?: (data: GetVideoResumeTemplateByIdAPIResponse) => void,
) => {
	return useQuery({
		queryKey: ['getVideoResumeTemplateByRole', role],
		queryFn: async () => (await getVideoResumeTemplateByRole(role)) as GetVideoResumeTemplateByIdAPIResponse,
		staleTime: 0,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
	});
};
